// extracted by mini-css-extract-plugin
export var actions = "_ss-4";
export var item = "_ss-1";
export var price = "_ss-3";
export var quantity = "_ss-2";
export var table = "_ss-0";